import type { PropsWithChildren } from 'react'
import { useCallback } from 'react'
import * as React from 'react'
import { useIntl } from 'react-intl'
import tripPlannerGlossaryMessages from 'tripPlanner/i18n/tripPlannerGlossaryMessages'

import TextButton from 'LuxKit/Button/TextButton'
import LineHeartIcon from 'LuxKit/Icons/line/LineHeartIcon'
import SolidHeartIcon from 'LuxKit/Icons/solid/SolidHeartIcon'
import { preventDefault, stopPropagation } from 'lib/web/eventHandlerUtils'

interface Props {
  onClick?: () => void
  isSaved?: boolean
  isProcessing?: boolean
}

function BaseBookmarkButton(props: PropsWithChildren<Props>) {
  const { onClick, isSaved = false, isProcessing = false } = props
  const intl = useIntl()
  const savedLabel = intl.formatMessage({
    id: '2HUc2BCWYtlsuyTSOhHz',
    defaultMessage: 'Saved',
    description: 'Label shown when item is already saved to a trip in the trip planner bookmarks',
  })
  const saveToTripLabel = intl.formatMessage(tripPlannerGlossaryMessages.saveToTrip)
  const savedIcon = isSaved ? (
    <SolidHeartIcon colour={isProcessing ? 'neutral-four' : 'favourite'} />
  ) : (
    <LineHeartIcon colour={isProcessing ? 'neutral-four' : undefined} />
  )

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      preventDefault(e)
      stopPropagation(e)

      onClick?.()
    },
    [onClick],
  )

  return (
    <TextButton
      kind="secondary"
      onClick={handleClick}
      disabled={isProcessing}
      size="large"
      startIcon={savedIcon}
    >
      {isSaved ? savedLabel : saveToTripLabel}
    </TextButton>
  )
}

export default React.memo(BaseBookmarkButton)
